import TableHeading from 'components/TableHeading';
import { useEntityPageContext } from './EntityContext';

/**
 * A tab holding nothing but the chart: a heading with the download button, and
 * the chart under it.
 *
 * `refOnWrapper` is a DOM fact, not a preference: the download button
 * screenshots whatever the ref points at, so Google and pop-index need it on a
 * wrapping div rather than on the chart.
 */
const EntityTimeSeriesTab = ({
    title,
    subtitle,
    tooltipKey,
    download,
    refOnWrapper = false,
    children,
}) => {
    const { timeSeriesRef } = useEntityPageContext();

    return (
        <>
            <TableHeading
                title={title}
                subtitle={subtitle}
                tooltipKey={tooltipKey}
                tooltipExample={null}
                tools={download}
            />
            <div
                css={`
                    padding: ${({ theme }) => theme.space_10}px;
                `}
            >
                {refOnWrapper ? (
                    <div ref={timeSeriesRef}>{children}</div>
                ) : (
                    children
                )}
            </div>
        </>
    );
};

export default EntityTimeSeriesTab;
